import React from "react";
import { Modal, Row, Col, Button, FormInstance } from "antd";
import styles from "./PersonModals.module.scss";
import { useWindowSize } from "../../../hooks/useWindowSize";

type Props = {
  form: FormInstance;
  visible: boolean;
  setVisibility: Function;
  validateForm: Function;
  serviceUserfirstName: string;
};

function DuplicateTrustedContactModal({
  form,
  visible,
  setVisibility,
  validateForm,
  serviceUserfirstName,
}: Props) {
  const { width } = useWindowSize();

  function handleCancel() {
    setVisibility(false);
  }

  function handleAddSomeoneElse() {
    form.resetFields();
    validateForm();
    setVisibility(false);
  }

  return (
    <Modal
      visible={visible}
      className={styles.duplicateTrustedContactContainer}
      centered={width < 992}
      width={width < 992 ? "unset" : "547px"}
      footer={
        <Row justify="center" gutter={[10, 15]}>
          <Col>
            <Button className={styles.cancel} onClick={handleCancel}>
              Cancel
            </Button>
          </Col>
          <Col>
            <Button
              className={styles.addSomeoneElse}
              onClick={handleAddSomeoneElse}
            >
              Add Someone Else
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center">
        <Col span={24} className={styles.title}>
          Duplicate Trusted Contact
        </Col>
      </Row>

      <Row gutter={[0, 30]}>
        <Col xs={2} lg={0} />
        <Col xs={20} lg={24} className={styles.description}>
          This person is already set up to receive information about{" "}
          {serviceUserfirstName}'s services.
        </Col>
        <Col xs={2} lg={0} />

        <Col xs={3} lg={0} />
        <Col xs={18} lg={24} className={styles.description}>
          Would you like to add someone else?
        </Col>
        <Col xs={3} lg={0} />
      </Row>
    </Modal>
  );
}

export default DuplicateTrustedContactModal;
